var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.249,
    height: 24.178,
    viewBox: "0 0 19.249 24.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_169_1",
    "data-name": "Component 169 \\u2013 1",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9510",
    "data-name": "Path 9510",
    d: "M6.232,4H19.785a2.464,2.464,0,0,1,2.464,2.464V21.249a2.464,2.464,0,0,1-2.464,2.464H6.232A1.232,1.232,0,0,1,5,22.481V5.232A1.232,1.232,0,0,1,6.232,4m3.7,0V26.178",
    transform: "translate(-5 -4)",
    fill: "none",
    stroke: "#383c3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9511",
    "data-name": "Path 9511",
    d: "M13,8h2.464",
    transform: "translate(-3.143 -3.072)",
    fill: "none",
    stroke: "#383c3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    "data-name": "Path 9512",
    d: "M13,12h2.464",
    transform: "translate(-3.143 -2.144)",
    fill: "none",
    stroke: "#383c3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.1637b645cdddf9e01c8239ff6ea46d14.svg";
export { ForwardRef as ReactComponent };